export default function TripConfirmationCard({
  confirmationText,
  systemLabel = "System",
  fallbackTitle = "Transfer Confirmation",
}) {
  if (!confirmationText) return null;

  const lines = confirmationText.split("\n");
  const title = lines[0] || fallbackTitle;
  const body = lines.slice(1).join("\n").trim();

  return (
    <section className="rounded-2xl border border-amber-200 bg-amber-50 p-4 shadow-sm">
      <div className="mb-2 inline-flex rounded-full border border-amber-200 bg-white px-2 py-0.5 text-[11px] font-semibold text-amber-800">
        {systemLabel}
      </div>
      <h2 className="text-lg font-semibold text-stone-900">{title}</h2>
      <pre className="mt-3 whitespace-pre-wrap break-words font-sans text-sm leading-6 text-stone-800">
        {body}
      </pre>
    </section>
  );
}
